import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { MatterUpdateUsersRequestDto } from '../../../../backend/src/matter/dto/matter-update-users.request.dto';
import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useUpdateMatterUsers = (id: string | undefined) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const updateMatterUsers = async (data: MatterUpdateUsersRequestDto) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.PATCH,
      data,
    });

    const response = await fetch(`${APIBaseChronos}/api/matters/${id}/users`, fetchConfig);
    if (!response.ok) {
      throw new Error('Error updating matter users');
    }
  };

  return useMutation({
    mutationFn: updateMatterUsers,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryEntity.Matter, { matterId: id }] });
    },
    onError: (error: Error) => {
      console.error('Update matter users error:', error);
      toast.error(error.message || 'Failed to update matter users. Please try again.');
    },
  });
};
